import React from 'react';
import { FacebookIcon, InstagramIcon, MessageCircleIcon, GlobeIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { copy } from '../data/copy';
import { business, contacts, images } from '../data/business';
import { Logo } from './Logo';
const quickLinks = [{
  href: '#home',
  key: 'navHome'
}, {
  href: '#services',
  key: 'navServices'
}, {
  href: '#gallery',
  key: 'navGallery'
}, {
  href: '#about',
  key: 'navAbout'
}, {
  href: '#faq',
  key: 'navFaq'
}, {
  href: '#contact',
  key: 'navContact'
}] as const;
const serviceLinks = [{
  en: 'Deep Cleaning',
  es: 'Limpieza Profunda'
}, {
  en: 'Regular Cleaning',
  es: 'Limpieza Regular'
}, {
  en: 'Bathroom Cleaning',
  es: 'Limpieza de Baños'
}, {
  en: 'Kitchen Cleaning',
  es: 'Limpieza de Cocina'
}, {
  en: 'Move-in / Move-out',
  es: 'Mudanza de Entrada / Salida'
}, {
  en: 'Specialized Services',
  es: 'Servicios Especializados'
}];
export function Footer() {
  const {
    t,
    lang,
    toggle
  } = useLanguage();
  return <footer className="bg-white" data-id="element-143" data-mp="3lalgthavm9v0">
      <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8" data-id="element-144" data-mp="3l9sin4pzgsoh">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4" data-id="element-145" data-mp="3gbijyk51v9y4">
          <div data-id="element-146" data-mp="3v7gbfp413q40">
            <Logo size="footer" data-id="element-147" data-mp="3v7zvbbd8ooko" />
            <div className="mt-5 flex items-start gap-4" data-id="element-148" data-mp="3v919vptgrt75">
              <img src={images.mascot} alt="" className="h-20 w-auto mix-blend-multiply" aria-hidden="true" data-id="element-149" data-mp="3q8dk17gz1iei" />
              <p className="mt-1 text-sm leading-relaxed text-charcoal/70" data-id="element-150" data-mp="34gwdfwv2p72">{t(copy.footerAbout)}</p>
            </div>
            <div className="mt-5 flex items-center gap-2" data-id="element-151" data-mp="ht3d9m24zp0e">
              <a href={business.social.facebook} target="_blank" rel="noreferrer" aria-label="Facebook" className="rounded-lg border border-navy/10 p-2.5 text-royal transition-colors duration-150 ease-out hover:bg-royal hover:text-white" data-id="element-152" data-mp="huo8ldw9zbzb">
                <FacebookIcon className="h-4 w-4" aria-hidden="true" data-id="element-153" data-mp="tvw7cfth7dfg" />
              </a>
              <a href={business.social.instagram} target="_blank" rel="noreferrer" aria-label="Instagram" className="rounded-lg border border-navy/10 p-2.5 text-royal transition-colors duration-150 ease-out hover:bg-royal hover:text-white" data-id="element-154" data-mp="ytoay73hgnzh">
                <InstagramIcon className="h-4 w-4" aria-hidden="true" data-id="element-155" data-mp="1cl2s08dtyf3w" />
              </a>
              <a href={business.whatsappHref} target="_blank" rel="noreferrer" aria-label={t(copy.whatsappUs)} className="rounded-lg border border-navy/10 p-2.5 text-royal transition-colors duration-150 ease-out hover:bg-royal hover:text-white" data-id="element-156" data-mp="1hje1uj44kpm4">
                <MessageCircleIcon className="h-4 w-4" aria-hidden="true" data-id="element-157" data-mp="3odhwd29jifsq" />
              </a>
            </div>
          </div>

          <nav aria-label={t(copy.footerQuickLinks)} data-id="element-158" data-mp="2afnbh94hzvyp">
            <h2 className="font-display text-sm font-extrabold uppercase tracking-[0.12em] text-navy" data-id="element-159" data-mp="2agey3ug4ajcu">
              {t(copy.footerQuickLinks)}
            </h2>
            <ul className="mt-4 space-y-2.5" data-id="element-160" data-mp="21nv4j8eon4yv">
              {quickLinks.map(link => <li key={link.href} data-id="element-161" data-mp="1woi75tq6qfi1">
                  <a href={link.href} className="text-sm text-charcoal/70 transition-colors duration-150 ease-out hover:text-royal" data-id="element-162" data-mp="1wpjuawkh6sg4">
                    {t(copy[link.key])}
                  </a>
                </li>)}
            </ul>
          </nav>

          <div data-id="element-163" data-mp="2kf4gdobxe5tm">
            <h2 className="font-display text-sm font-extrabold uppercase tracking-[0.12em] text-navy" data-id="element-164" data-mp="2fegoz1jsbmyv">
              {t(copy.footerServices)}
            </h2>
            <ul className="mt-4 space-y-2.5" data-id="element-165" data-mp="18zfqop7aesp4">
              {serviceLinks.map(service => <li key={service.en} data-id="element-166" data-mp="13xgq1n2xm9vv">
                  <a href="#services" className="text-sm text-charcoal/70 transition-colors duration-150 ease-out hover:text-royal" data-id="element-167" data-mp="2rvr5f9fqaecp">
                    {t(service)}
                  </a>
                </li>)}
            </ul>
          </div>

          <div data-id="element-168" data-mp="2ntmi0sfvidyi">
            <h2 className="font-display text-sm font-extrabold uppercase tracking-[0.12em] text-navy" data-id="element-169" data-mp="2nv7c6gy9zuvu">
              {t(copy.footerContact)}
            </h2>
            <ul className="mt-4 space-y-2.5 text-sm" data-id="element-170" data-mp="3flbri176hrq7">
              {contacts.map(contact => <li key={contact.id} data-id="element-171" data-mp="31lj6mmic25q5">
                  <a href={contact.phoneHref} className="font-display font-bold text-royal transition-colors duration-150 ease-out hover:text-bright" data-id="element-172" data-mp="31khibgcb3mqh">
                    {contact.name}: {contact.phone}
                  </a>
                </li>)}
              {contacts.map(contact => <li key={`wa-${contact.id}`} data-id="element-173" data-mp="1nlxwqljj8d2c">
                  <a href={contact.whatsappHref} target="_blank" rel="noreferrer" className="text-charcoal/70 transition-colors duration-150 ease-out hover:text-royal" data-id="element-174" data-mp="1nkmoo9j20j5f">
                    WhatsApp {contact.name}: {contact.phone}
                  </a>
                </li>)}
              <li data-id="element-175" data-mp="13z04g08bcuoo">
                <a href={business.emailHref} className="break-all text-charcoal/70 transition-colors duration-150 ease-out hover:text-royal" data-id="element-176" data-mp="13yhyuczrh443">
                  {t(copy.emailLabel)}: {business.email}
                </a>
              </li>
              <li className="text-charcoal/70" data-id="element-177" data-mp="18w9tvfvpd6ci">
                {t(copy.footerHours)}: {t(copy.areaHours)}
              </li>
              <li className="font-semibold text-bright" data-id="element-178" data-mp="l5e2ukz2mf6b">{t(copy.sameDay)}</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-navy/10" data-id="element-179" data-mp="2gax3030soica">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-4 px-4 py-6 sm:flex-row sm:px-6 lg:px-8" data-id="element-180" data-mp="2ga3zdax4u8yd">
          <p className="text-xs text-charcoal/60" data-id="element-181" data-mp="2q0gj50x4hy3g">
            © {new Date().getFullYear()} {business.name}. {t(copy.footerRights)} · {business.website}
          </p>
          <div className="flex items-center gap-5" data-id="element-182" data-mp="2uyqfvfyhx6r6">
            <a href="#faq" className="text-xs text-charcoal/60 hover:text-royal" data-id="element-183" data-mp="1xcawu9qf811i">
              {t(copy.privacy)}
            </a>
            <a href="#faq" className="text-xs text-charcoal/60 hover:text-royal" data-id="element-184" data-mp="22bnm114rlk79">
              {t(copy.terms)}
            </a>
            <button type="button" onClick={toggle} aria-label={t(copy.langToggle)} className="flex items-center gap-1.5 rounded-lg border border-navy/15 px-2.5 py-1.5 font-display text-xs font-bold text-charcoal transition-colors duration-150 ease-out hover:border-bright" data-id="element-185" data-mp="27c1vmnm0l27e">
              <GlobeIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-186" data-mp="1b3vuha9o78d0" />
              <span className={lang === 'en' ? 'text-royal' : 'text-charcoal/50'} data-id="element-187" data-mp="171r0gafb89pu">EN</span>
              <span aria-hidden="true" className="text-charcoal/30" data-id="element-188" data-mp="1744ucfy97fvt">
                /
              </span>
              <span className={lang === 'es' ? 'text-royal' : 'text-charcoal/50'} data-id="element-189" data-mp="xbz3j9jqn4i7">ES</span>
            </button>
          </div>
        </div>
      </div>
    </footer>;
}